import AppBootLoader from './AppBootLoader'

export default function StartingLoader() {
  return <AppBootLoader message="Navigating..." hideOnUnmount />
}
